import React from 'react';

const Circle = () => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="7.5" cy="7.5" r="6.5" stroke="#C7C8CC" strokeWidth="2" />
    </svg>
);

export default Circle;
